<!-- <base-widget-settings> -->

<dx-popup
    [showTitle]="true"
    title="Settings"
    [dragEnabled]="false"
    [hideOnOutsideClick]="true"
    [showCloseButton]="false"
    [visible]="visible"
    [toolbarItems]="toolbarItems"
    [maxWidth]="500"
    [height]="'auto'"
>   
    <dx-form 
    [formData]="formData"
    [labelMode]="'floating'"
    (onFieldDataChanged)="onFormChanged($event)"
    >
        <dxi-item
            dataField="machineName"
            editorType="dxSelectBox"
            [isRequired]="true"
            [editorOptions]="{
                dataSource: selectOptions,
                displayExpr: 'name',
                valueExpr: 'name',
                placeholder: 'Select machine',
            }">
        </dxi-item>

        <dxi-item
            dataField="graphType"
            editorType="dxSelectBox"
            [isRequired]="true"
            [editorOptions]="{
                dataSource: graphTypeSource,
                displayExpr: 'value',
                valueExpr: 'key',
                placeholder: 'Select graph type',
            }">
        </dxi-item>

        <dxi-item
            dataField="series"
            editorType="dxSelectBox"
            [isRequired]="true"
            [editorOptions]="{
                dataSource: seriesSource,
                placeholder: 'Select serie',
            }">
        </dxi-item>

        <dxi-item
            dataField="bufferSize"
            editorType="dxNumberBox"
            *ngIf="isLineTypeCallback()"
        >
            <dxi-validation-rule 
                type="required"
                [message]="'This field is required when graph type is line.'"
                [reevaluate]="true"
                [validationCallback]="isLineTypeCallback">
            </dxi-validation-rule>
        </dxi-item>

        <dxi-item
            dataField="valueAxisAutoSacle"
            editorType="dxCheckBox"
        >
        </dxi-item>

        <ng-container *ngIf="formData?.valueAxisAutoSacle === true">
            <dxi-item
                dataField="tickInterval"
                editorType="dxNumberBox"
            >
                <dxi-validation-rule 
                    type="required"
                    [message]="'This field is required when auto scale is checked.'"
                    [reevaluate]="true"
                    [validationCallback]="isAutoScaleCallback">
                </dxi-validation-rule>
            </dxi-item>
        </ng-container>

        <ng-container *ngIf="formData?.valueAxisAutoSacle === false">
            <dxi-item
                dataField="valueVisualRange.min"
                editorType="dxNumberBox"
            >
                <dxi-validation-rule 
                    type="required"
                    [message]="'This field is required when auto scale is unchecked.'"
                    [reevaluate]="true"
                    [validationCallback]="isFixedSacleCallback">
                </dxi-validation-rule>
            </dxi-item>

            <dxi-item
                dataField="valueVisualRange.max"
                editorType="dxNumberBox"
            >
                <dxi-validation-rule 
                    type="required"
                    [message]="'This field is required when auto scale is unchecked.'"
                    [reevaluate]="true"
                    [validationCallback]="isFixedSacleCallback">
                </dxi-validation-rule>
            </dxi-item>
        </ng-container>
    </dx-form>
</dx-popup>